/* global ol */
export default class ExtremeMapLandmarkLayerManager {
  constructor() {
    if (this.constructor === ExtremeMapLandmarkLayerManager) {
      throw new TypeError('Abstract class "ExtremeMapLandmarkLayerManager" cannot be instantiated directly.')
    }

    this.layer = null
    this.layerInfo = {
      extent: null,
    }
  }

  isArrayAllSame(a, b) {
    const aLen = a.length
    const bLen = b.length
    if (aLen !== bLen) { return false }
    a = a.slice().sort()
    b = b.slice().sort()
    for (let i = 0; i < aLen; i++) {
      if (a[i] !== b[i]) { return false }
    }
    return true
  }

  coordFromLonLat(coord, opt = {}) {
    const destProj = opt.destProj || 'EPSG:3857'
    return ol.proj.fromLonLat(coord, destProj)
  }

  convCoord({ lat, lon }, opt = {}) {
    const srcProj = opt.srcProj || 'EPSG:4326'
    const destProj = opt.destProj || 'EPSG:3857'
    return ol.proj.transform([lon, lat], srcProj, destProj)
  }

  convGeometry(geom, opt = {}) {
    const srcProj = opt.srcProj || 'EPSG:4326'
    const destProj = opt.destProj || 'EPSG:3857'
    return geom.clone().transform(srcProj, destProj)
  }

  getLayer() {
    const layer = this.layer
    const layerInfo = this.layerInfo
    return { layer, layerInfo }
  }

  getStream() {
    return this.stream
  }

  setStream(stream) {
    this.stream = stream
    this.setListeners_()
  }

  setListeners_() {
    // implement in child class
  }
}
